import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Cargar usuario del localStorage al montar
  useEffect(() => {
    const savedUser = localStorage.getItem('laorda_user');
    if (savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (e) {
        console.error('Error loading user:', e);
      }
    }
  }, []);

  const login = async (email, password) => {
    setIsLoading(true);
    try {
      // Simulación de login (sin backend)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const userData = {
        id: Math.random().toString(36).substr(2, 9),
        email,
        nombre: email.split('@')[0],
        avatar: `https://ui-avatars.com/api/?name=${email.split('@')[0]}&background=3388EE&color=fff`
      };
      
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('laorda_user', JSON.stringify(userData));
      
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Error al iniciar sesión' };
    } finally {
      setIsLoading(false);
    }
  };

  const register = async (data) => {
    setIsLoading(true);
    try {
      // Simulación de registro
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      const userData = {
        id: Math.random().toString(36).substr(2, 9),
        email: data.email,
        nombre: data.nombre,
        apellido: data.apellido,
        avatar: `https://ui-avatars.com/api/?name=${data.nombre}+${data.apellido}&background=3388EE&color=fff`
      };
      
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem('laorda_user', JSON.stringify(userData));
      
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Error al crear la cuenta' };
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('laorda_user');
  };

  const forgotPassword = async (email) => {
    setIsLoading(true);
    try {
      // Simulación de envío de email
      await new Promise(resolve => setTimeout(resolve, 1000));
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Error al enviar el email' };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    forgotPassword
  };
};